import _regeneratorRuntime from "/usr/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import stl from './NewArrivalsNotificationModal.module.css';
import { useTranslation } from "@i18n";
import Button from "@/components/UiKit/Button/Button";
import { api__updateCustomer } from "@/apis/customer/customer";
import toast from "react-hot-toast";
import { trackEvents } from "@/common/events/events";
import { CDN_LINK } from "@globalConfig";
import { useAuthActions, useSession } from "@/_MiniApps/auth/AuthContext";
import useCookieClient from "@hooks/useCookieClient";

/** ---------------------------------------- */

/** ---------------------------------------- */

var NewArrivalsNotificationModal = function NewArrivalsNotificationModal(_ref) {
  var onClose = _ref.onClose,
    thanksModalOpen = _ref.thanksModalOpen,
    openThanksModal = _ref.openThanksModal;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useSession = useSession(),
    userData = _useSession.user;
  var _useAuthActions = useAuthActions(),
    setUserData = _useAuthActions.setUserData;
  var _useCookieClient = useCookieClient(),
    getCookieClient = _useCookieClient.getCookieClient;
  var handleAcceptNotification = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return api__updateCustomer({
              opt_whatsapp_interest: 1
            });
          case 3:
            res = _context.sent;
            if (res.success) {
              openThanksModal();
              setUserData(_objectSpread(_objectSpread({}, userData), {}, {
                opt_whatsapp_interest: 1
              }));
              trackEvents("notification_popup_response", {
                user_id: (userData === null || userData === void 0 ? void 0 : userData.phone_number) || null,
                uuid: getCookieClient("UUID"),
                popup_response: "Yes"
              });
            }
            _context.next = 12;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            onClose();
            toast.error(t("حدث خطأ ما", {
              ns: "new_arrivals"
            }));
            console.log(_context.t0);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
    return function handleAcceptNotification() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement("div", {
    className: stl.newArrivalModalWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.upperSection
  }, thanksModalOpen ? /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/check-payment.svg",
    alt: "",
    className: stl.thanksModalIcon
  }) : /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/favorite-icon.svg",
    alt: ""
  })), thanksModalOpen ? /*#__PURE__*/React.createElement("div", {
    className: stl.thanKdownSection
  }, /*#__PURE__*/React.createElement("h3", {
    className: stl.modalHead
  }, t("شكرًا لك!", {
    ns: "new_arrivals"
  })), /*#__PURE__*/React.createElement("p", {
    className: stl.modalText
  }, t("سيتم إشعارك عندما يتم إضافة سيارات مطابقة لمفضلتك", {
    ns: "new_arrivals"
  }))) : /*#__PURE__*/React.createElement("div", {
    className: stl.downSection
  }, /*#__PURE__*/React.createElement("h3", {
    className: stl.modalHead
  }, t("رائع!", {
    ns: "new_arrivals"
  })), /*#__PURE__*/React.createElement("p", {
    className: stl.modalText
  }, t("هل ترغب في تلقي إشعارات عن السيارات الجديدة التي تطابق مفضلتك؟", {
    ns: "new_arrivals"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.whatsappSection
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/whatsapp-icon.svg",
    alt: ""
  }), /*#__PURE__*/React.createElement("p", {
    className: stl.whatsText
  }, t("سيتم ارسال الاشعارات من خلال واتساب.", {
    ns: "new_arrivals"
  }))), /*#__PURE__*/React.createElement(Button, {
    type: 'default',
    className: stl.modalButton,
    onClick: handleAcceptNotification
  }, t("نعم", {
    ns: "new_arrivals"
  }))));
};
export default NewArrivalsNotificationModal;